
@if(haveSession()){
  <ta-layout></ta-layout>
} @else {
  <main class="auth-splash">
    <img src="assets/images/council-logo-text.svg" alt="Central Land Council Logo" class="mb-4" />
    <h3 class="text-xl md:text-5xl mb-16">Travel Allowance Platform</h3>
    <p-progressBar mode="indeterminate" [style]="{height: '6px', width: '33%'}"></p-progressBar>
    <div class="status-message mt-8">
      Logging you in...
    </div>
  </main>
}
<loading-indicator [isGlobal]="true"></loading-indicator>
